import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Redirect path berdasarkan role ketika akses ditolak (bukan admin/superadmin).
 * Karyawan & kasir tidak boleh akses dashboard admin/superadmin.
 */
const getRedirectByRole = (role) => {
  switch (role) {
    case 'kasir':
      return '/transaksikasir';
    case 'karyawan':
    case 'dapur':
      return '/dashboardkaryawan';
    default:
      return '/dashboard';
  }
};

/**
 * PrivateRoute: proteksi route berdasarkan auth (session /me) dan optional allowedRoles.
 * - Tanpa allowedRoles: semua user yang sudah login boleh akses.
 * - Dengan allowedRoles: hanya role yang ada di array boleh akses; lainnya di-redirect.
 * Karyawan dan kasir yang akses route admin/superadmin akan diarahkan ke dashboard mereka.
 */
export const PrivateRoute = ({ element, allowedRoles, redirectTo }) => {
  const { user, isAuthenticated, isLoading, isInitialized } = useSelector((state) => state.auth);

  // Hanya tampilkan loading saat initial load (belum ada user). Jangan saat isLoading
  // yang dipicu Me() dari child, agar child tidak unmount -> loop.
  if (!isInitialized || (!user && isLoading)) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="40vh" gap={2}>
        <CircularProgress />
        <Typography color="text.secondary">Memuat...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    const to = redirectTo || getRedirectByRole(user.role);
    return <Navigate to={to} replace />;
  }

  return element;
};
